import React from "react";
import SelfClearingNumericTextBox from "../DataGridCells/SelfClearingNumericTextBox/SelfClearingNumericTextBox";
import "./NumericalTextBox.scss";

const NumericalTextBox = (props) => {
  console.log("Hide Arrows?", props);

  return (
    <div className={"instream-numerical-textbox"}>
      <SelfClearingNumericTextBox
        {...props}
        label={props.label}
        value={props.value}
      />
    </div>
  );
};

export default NumericalTextBox;
